import { Component, ChangeDetectorRef } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SharedModule } from '../../shared.module';

@Component({
  selector: 'app-loader',
  imports: [SharedModule,MatProgressSpinnerModule],
  templateUrl: './loader.html',
  styleUrl: './loader.scss'
})
export class Loader {

  public isLoaderOn = false;
  constructor(public loaderService: LoaderService, private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.loaderService.isLoaderOn.subscribe({
      next: (status: boolean) => {
        this.isLoaderOn = status;
        this.cdr.detectChanges(); // Manually trigger change detection
      }
      , error: (err: any) => { }
    });
  }
}
